// src/config/brand.js

/**
 * Single source of truth for brand identity.
 *
 * Renaming the platform should only require editing the constants at the top of
 * this file. Import from here rather than hardcoding the brand name, addresses,
 * or product labels anywhere else in the app.
 *
 * The Cloud Functions package has its own copy (functions/emailtrigger/brand.js)
 * because it cannot import from src/. Keep the two in sync when renaming.
 */

const NAME = "SkillSyncs";
const DOMAIN = "skillsyncs.com";
const ADMIN_EMAIL = "skillsyncs@outlook.com";

const PRODUCT_NAME = `${NAME} Intelligence`;
const NO_REPLY_EMAIL = `noreply@${DOMAIN}`;

export const BRAND = {
  /** Short brand name, used in navigation, titles, and body copy. */
  name: NAME,
  /** Full product name, used in report headers and transactional email. */
  productName: PRODUCT_NAME,
  tagline: "Real help for real tech problems",

  domain: DOMAIN,
  url: `https://${DOMAIN}`,

  /** Operations inbox that receives a copy of every incident report. */
  adminEmail: ADMIN_EMAIL,
  noReplyEmail: NO_REPLY_EMAIL,
  emailFrom: `${PRODUCT_NAME} Team <${NO_REPLY_EMAIL}>`,

  /** Primary brand colour; matches theme-color in public/index.html. */
  themeColor: "#0E3B8E",

  /** Prefix for human-readable incident report IDs (INC-2026-000123). */
  incidentIdPrefix: "INC",
};

export default BRAND;
